import { defineElement, FC, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { ButtonA, Container } from '@bpd-library/components';
import { useStylesheet } from '@source/utilities/hooks';

import style from './error-page.scss';
import { ErrorPageIllustration } from './utilities/illustration';

const ErrorPage: FC = () => {
    const [titleNl] = useProp<string>('titleNl');
    const [titleDe] = useProp<string>('titleDe');
    const [titleEn] = useProp<string>('titleEn');

    const [subtitleNl] = useProp<string>('subtitleNl');
    const [subtitleDe] = useProp<string>('subtitleDe');
    const [subtitleEn] = useProp<string>('subtitleEn');

    const [buttonLabelNl] = useProp<string | null>('buttonLabelNl', null);
    const [buttonLabelDe] = useProp<string | null>('buttonLabelDe', null);
    const [buttonLabelEn] = useProp<string | null>('buttonLabelEn', null);

    let title: string;
    let subtitle: string;
    let buttonLabel: string | null;

    if (navigator.language.includes('de')) {
        title = titleDe;
        subtitle = subtitleDe;
        buttonLabel = buttonLabelDe;
    } else if (navigator.language.includes('en')) {
        title = titleEn;
        subtitle = subtitleEn;
        buttonLabel = buttonLabelEn;
    } else {
        title = titleNl;
        subtitle = subtitleNl;
        buttonLabel = buttonLabelNl;
    }

    useStylesheet(style);

    return (
        <Container extraClass="error-page__container u-flex u-flex-column u-flex-center u-flex-middle">
            <div class="error-page__image">
                <ErrorPageIllustration />
            </div>

            <h1 class="error-page__title u-h3 u-h1--md">{title}</h1>
            <p>{subtitle}</p>

            {buttonLabel && (
                <ButtonA
                    url={window.location.href}
                    label={buttonLabel}
                    classes="error-page__button"
                />
            )}
        </Container>
    );
};

ErrorPage.props = {
    titleNl: {
        type: String,
        required: true,
    },
    titleDe: {
        type: String,
        required: true,
    },
    titleEn: {
        type: String,
        required: true,
    },
    subtitleNl: {
        type: String,
        required: true,
    },
    subtitleDe: {
        type: String,
        required: true,
    },
    subtitleEn: {
        type: String,
        required: true,
    },
    buttonLabelNl: {
        type: String,
    },
    buttonLabelDe: {
        type: String,
    },
    buttonLabelEn: {
        type: String,
    },
};

defineElement('error-page', ErrorPage);
